import { Globe, Search, Palette, PenTool, Smartphone, Shield } from "lucide-react";

export const Services = ({ t }) => {
  return (
    <section id="servicos" data-testid="services-section" className="section-darker py-24 md:py-32 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="mb-16 md:mb-24">
          <span className="text-sm tracking-[0.3em] uppercase text-[#C5A059] block mb-4">{t.services.badge}</span>
          <h2 data-testid="services-title" className="text-4xl md:text-5xl font-medium tracking-tight text-[#E5E5E5] max-w-2xl line-accent" style={{ fontFamily: "'Playfair Display', serif" }}>
            {t.services.title} <span className="text-gold-gradient">{t.services.highlight}</span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {/* Main Card */}
          <div data-testid="service-card-websites" className="service-card lg:col-span-2 lg:row-span-2 glass-card p-8 md:p-12 bento-item group">
            <div className="h-full flex flex-col justify-between">
              <div>
                <div className="w-14 h-14 border border-[#C5A059]/30 flex items-center justify-center mb-8 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                  <Globe className="w-6 h-6 text-[#C5A059]" />
                </div>
                <h3 className="text-2xl md:text-3xl font-medium text-[#E5E5E5] mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>{t.services.main.title}</h3>
                <p className="text-[#A3A3A3] leading-relaxed text-lg">{t.services.main.desc}</p>
              </div>
              <div className="mt-8 pt-8 border-t border-white/10">
                <ul className="space-y-3">
                  <li className="flex items-center gap-3 text-[#A3A3A3]"><span className="w-1.5 h-1.5 bg-[#C5A059]" />{t.services.main.features[0]}</li>
                  <li className="flex items-center gap-3 text-[#A3A3A3]"><span className="w-1.5 h-1.5 bg-[#C5A059]" />{t.services.main.features[1]}</li>
                  <li className="flex items-center gap-3 text-[#A3A3A3]"><span className="w-1.5 h-1.5 bg-[#C5A059]" />{t.services.main.features[2]}</li>
                </ul>
              </div>
            </div>
          </div>

          {/* SEO Card */}
          <div className="service-card glass-card p-6 md:p-8 bento-item group">
            <div className="w-12 h-12 border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
              <Search className="w-5 h-5 text-[#C5A059]" />
            </div>
            <h3 className="text-xl font-medium text-[#E5E5E5] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{t.services.seo.title}</h3>
            <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.services.seo.desc}</p>
          </div>

          {/* Branding Card */}
          <div className="service-card glass-card p-6 md:p-8 bento-item group">
            <div className="w-12 h-12 border border-[#C5A059]/30 flex items-center justify-center mb-6 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
              <Palette className="w-5 h-5 text-[#C5A059]" />
            </div>
            <h3 className="text-xl font-medium text-[#E5E5E5] mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>{t.services.branding.title}</h3>
            <p className="text-[#A3A3A3] text-sm leading-relaxed">{t.services.branding.desc}</p>
          </div>

          {/* Small Cards */}
          <div className="service-card glass-card p-6 bento-item group">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <PenTool className="w-4 h-4 text-[#C5A059]" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-[#E5E5E5] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{t.services.copy.title}</h3>
                <p className="text-[#A3A3A3] text-sm">{t.services.copy.desc}</p>
              </div>
            </div>
          </div>

          <div className="service-card glass-card p-6 bento-item group">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <Smartphone className="w-4 h-4 text-[#C5A059]" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-[#E5E5E5] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{t.services.responsive.title}</h3>
                <p className="text-[#A3A3A3] text-sm">{t.services.responsive.desc}</p>
              </div>
            </div>
          </div>

          <div className="service-card glass-card p-6 bento-item group">
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 border border-[#C5A059]/30 flex items-center justify-center flex-shrink-0 group-hover:bg-[#C5A059]/10 transition-colors duration-300">
                <Shield className="w-4 h-4 text-[#C5A059]" />
              </div>
              <div>
                <h3 className="text-lg font-medium text-[#E5E5E5] mb-1" style={{ fontFamily: "'Playfair Display', serif" }}>{t.services.gdpr.title}</h3>
                <p className="text-[#A3A3A3] text-sm">{t.services.gdpr.desc}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
